export default "__VITE_ASSET__BJlyOqiQ__"